export default "__VITE_ASSET__Cu8s5nka__"